(function() {
  "use strict";


  angular.module("PrintQueueDriverList")


    .constant("DRIVER_FILTERS", [{
      name: "LatestVersion",
      parameter: "latestVersion",
      type: "checkbox",
      values: [
        {
          key: 'true',
          value: 'LatestVersion',
          type: 'checkbox',
        }
      ]
    },
    {
      name: "Language",
      parameter: 'language',
      type: 'checkbox',
      values: [{
        key: 'MULTI',
        value: 'LanguageMultiple',
        type: 'checkbox',
      },
      {
        key: 'UNKNOWN',
        value: 'LanguageUnknown',
        type: 'checkbox',
        setBreaker: true
      }]
    }])

    .constant('SORT_DRIVERS', {
      VERSION: "DriverVersion",
      NAME: "DriverName",
      LANGUAGE: "DriverLanguage",
    })

    .controller("PrintQueueDriverListController", [
        "$rootScope", "$scope", "$location", "APIAdmin", "URLS", "SUPPORTED_OS",
        "focus", "$filter", "PrinterListService", "URL_PARAMS", "toastr",
        "$ngBootbox", "TEMPLATE_PATHS", "$routeParams", "PrintQueueListService",
        "$window", "DRIVER_FILTERS", "DriversListPaging", "SORT_DRIVERS", "$timeout", 'EventHandlerService',
        'TenantListService', 'NetworkListService', 'currentTenant',
      function(
        $rootScope, $scope, $location, APIAdmin, URLS, SUPPORTED_OS,
        $focus, $filter, PrinterListService, URL_PARAMS, toastr,
        $ngBootbox, TEMPLATE_PATHS, $routeParams, PrintQueueListService,
        $window, DRIVER_FILTERS, DriversListPaging, SORT_DRIVERS, $timeout, EventHandlerService,
        TenantListService, NetworkListService, currentTenant) {

        $scope.orderByText = "DriverName";
        $scope.searchInputFieldHolderFocusKey = "searchInputFieldHolderFocusKey";
        $scope.lastPageReached = true;
        $scope.printer = null;
        $scope.printQueue = null;
        $scope.printQueueDefaultDriverForOS = null;
        $scope.driverToEdit = null;
        $scope.supportedOs = SUPPORTED_OS;
        $scope.showSearchField = false;
        $scope.searchPattern = "";
        $scope.driverList = [];
        $scope.driverLanguages = [];

        $scope.currentPageNumber = 0;
        $scope.elementsToDisplay = 50;
        $scope.showOnlyUploadedPrintDrivers = false;
        $scope.currentDriver = null;
        $scope.newDriver = null;
        $scope.defaultDriver = {};
        $scope.fixDefaultDriver = false;
        $scope.helpCaption = 'HelpPrintQueueDriverListPage';
        $scope.driversListPagingObject = new DriversListPaging();
        $scope.driversListDataRaw = null;
        $scope.noDrivers = {};
        $scope.eventHandlerService = EventHandlerService;
        $scope.isThisResourceMine = true;
        $scope.tenant = currentTenant;

        (function(){
          initEventHandler();
        })();

        function initEventHandler() {
          $scope.eventHandlerService.deRegisterListeners();
        };

        $scope.$watch(function () {
          return $rootScope.currentUser
        }, function () {
          if ($rootScope.currentUser) {
            $scope.me = $rootScope.currentUser;
            getPrintQueue();
            findCorrectOS();
            setFilters();
          }
        });

        $scope.getDriversListPaged = function (clearDriverList){
          if (($scope.currentDriverReady && !$scope.gettingDrivers) || ($scope.noDrivers.currentDriver && $scope.noDrivers.defaultDriver && !$scope.gettingDrivers)) {
            $scope.driversListDataRaw = null
            $scope.gettingDrivers = true;
            if (clearDriverList) {
              $scope.driverList = [];
            }

            $timeout(function(){
              $scope.driversListPagingObject.pagingCriteria.os = $routeParams[URL_PARAMS.OS.ROUTE];
              APIAdmin.getDriversListPaged($scope.driversListPagingObject).then(function(response) {
                $scope.gettingDrivers = false;
                $scope.driversListDataRaw = response.data;
                if (response.data.page.totalElements) {
                  if ($scope.driverList.length > 0) {
                    angular.forEach(response.data._embedded['px:printerDriverResources'], function(driver) {
                      $scope.driverList.push(driver);
                    })
                  } else {
                    $scope.driverList = response.data._embedded['px:printerDriverResources'];
                  }
                  checkCurrentDriver();
                } else {
                  $scope.noDataMessage = $filter('translate')('NoSearchResultDriver');
                  $scope.driverList = [];
                }
                checkPagination(response.data.page);
              }).catch(function(error) {
                $scope.gettingDrivers = false;
              })
            }, 300);
          }
        }

        $scope.$watch("showOnlyUploadedPrintDrivers", function() {
          if ($scope.printer) {
            if ($scope.showOnlyUploadedPrintDrivers) {
              $scope.searchPattern = "";
              $scope.orderByValue = null;
              $scope.orderByText = null;
              $scope.driversListPagingObject.pagingCriteria.owned = true;
            } else {
              if ($scope.driver) {
                $scope.driversListPagingObject.pagingCriteria.owned = false;
                $scope.searchPattern = angular.copy($scope.driver.name);
              } else {
                $scope.driversListPagingObject.pagingCriteria.owned = false;
                $scope.searchPattern = angular.copy($scope.printer.info._embedded.printerModel.modelName);
              }
              $scope.orderByValue = "name";
              $scope.orderByText = "Name";
            }
            $scope.getDriversListPaged(true);
          }
        });

        function checkCurrentDriver () {
          if ($scope.currentDriver) {
            angular.forEach($scope.driverList, function(driver) {
              if ($scope.currentDriver.dbId === driver.dbId) {
                driver.isSelected = true;
              }
            })
          }
        }

        function checkPagination (metaPage) {
          if ((metaPage.number + 1) < metaPage.totalPages) {
            $scope.lastPageReached = false;
          } else {
            $scope.lastPageReached = true;
          }
        }

        $scope.loadMoreItems = function() {
          $scope.driversListPagingObject.pagingCriteria.page += 1;
          $scope.getDriversListPaged(false);
        };

        $scope.changeOrderByValue = function(textValue) {
          if ($scope.reverse) {
            $scope.reverse = false;
            $scope.driversListPagingObject.pagingCriteria.direction = 'ASC';
            $scope.driversListPagingObject.pagingCriteria.sort = textValue;
          } else {
            $scope.reverse = !$scope.reverse;
            $scope.driversListPagingObject.pagingCriteria.direction = 'DESC';
            $scope.driversListPagingObject.pagingCriteria.sort = textValue;
          }
          $scope.orderByText = SORT_DRIVERS[textValue];
          $scope.getDriversListPaged(true);
        };

        $scope.toggleShowSearchField = function($event) {
          if ($scope.showSearchField) {
            $scope.showSearchField = false;
          } else {
            $scope.showSearchField = true;
          }
          $event.preventDefault();
          $focus($scope.searchInputFieldHolderFocusKey);
        };

        $scope.checkForDriverConflicts = function (driver) {
          $scope.printQueue.checkForDriverConflicts($scope.os.key, driver._links.self.href).then(function(response){
            issueDriverConflictWarning(response.data.conflicts, response.data._embedded.printerQueue, driver);
          }).catch(function(error) {});
        }

        function sortArray(a,b) {
          if (a.signId < b.signId) {
            return -1;
          }
          if (a.signId > b.signId) {
            return 1;
          }
          return 0;
        }

        function removeThisPrintQueueFromConflictedPrintQueues(conflictedPrintQueues) {
          var conflictedPrintQueuesCleaned = [];
          var currentPrintQueueId = $scope.printQueue.info._links.self.href;
          for (var i = 0; i < conflictedPrintQueues.length; i++) {
            var conflictedPrintQueuesID = conflictedPrintQueues[i]._links.self.href;
            if (conflictedPrintQueuesID !== currentPrintQueueId) {
              conflictedPrintQueuesCleaned.push(conflictedPrintQueues[i]);
            }
          }
          return conflictedPrintQueuesCleaned;
        }

        function issueDriverConflictWarning (conflicts, conflictedPrintQueues, driver) {
          $scope.newDriver = driver;
          var driverName = getDriverConfigForOS($scope.os);
          var conflictedPrintQueuesCleaned = removeThisPrintQueueFromConflictedPrintQueues(conflictedPrintQueues);

          if (driverName) {
            $scope.driverConfigurationName = driverName;
            $scope.conflictDialogHeight = 200;
            $scope.issueWarning = true;
            $scope.showWarning();
          } else {
            $scope.issueWarning = false;
          }

        }

        $scope.showWarning = function (event) {
          if (event) {
            var eventX = event.clientX;
            var eventY = event.clientY;
            event.stopPropagation();
          }
          $scope.clearPopups();
          $scope.changeDriverWarningConfiguration = {
            queueWarningsList: $scope.driverConflicts,
            configurationName: $scope.driverConfigurationName
          };
          $scope.changeDriverPopupObject = {
            dimensions: {height: $scope.conflictDialogHeight, width: 400},
            offset: {top: -35, left: 57},
            pointerDirection: null,
            pointerPosition: 'middle',
            relativePosition: 'left',
            absoluteX: eventX ? eventX : $window.innerWidth / 2,
            absoluteY: eventY ? eventY : $window.innerHeight / 2,
            type: 'INFO_DIALOG',
            title: 'WARNING',
            confirmText: null,
            clickOutsideToClose: true
          }
        }

        $scope.clearPopups = function () {
          $scope.changeDriverPopupObject = null;
          $scope.changeDriverWarningConfiguration = null;
        }

        function getDriverConfigForOS (os) {
          if (os) {
            if ($scope.printQueue.info._embedded.driversAndConfigs) {
              var driverAndConfigForOs = $scope.printQueue.info._embedded.driversAndConfigs.findElement({
                os: os.key
              });
              if (driverAndConfigForOs && driverAndConfigForOs._links["px:driverConfig"] &&
                driverAndConfigForOs && driverAndConfigForOs._links["px:driverConfig"].href) {
                var driverConfig = PrinterListService.driverConfigs.findElement({ _links: { self: { href: driverAndConfigForOs._links["px:driverConfig"].href } } });
                if (driverConfig) {
                  return driverConfig.name;
                } else {
                  return false;
                }
              } else {
                return false;
              }
            } else {
              return false;
            }
          } else {
            throw "$scope.getDriverConfigForOS: os is missing";
          }
        };

        $scope.changeDriverSelectedState = function(driverReceived) {
          if (driverReceived) {
            var selectedDriverList = $scope.driverList.findAllElements({
              isSelected: true
            });
            angular.forEach(selectedDriverList, function(driver) {
              if (driver._links.self.href !== driverReceived._links.self.href) {
                driver.isSelected = false;
              }
              if ($scope.printQueueDefaultDriverForOS && driverReceived._links.self.href !== $scope.printQueueDefaultDriverForOS._links.self.href) {
                $scope.printQueueDefaultDriverForOS.isSelected = false;
              }
            });
          } else {
            throw "$scope.changeDriverSelectedState: driverReceived was null or empty";
          }
          $scope.checkForDriverConflicts(driverReceived);
        };

        $scope.editDriver = function(driver) {
          if (driver) {
            $scope.driverOriginal = angular.copy(driver);
            $scope.driverToEdit = angular.copy(driver);
            var driverEditOptions = {
              scope: $scope,
              templateUrl: TEMPLATE_PATHS.DRIVER_EDIT_DIALOG,
              title: $scope.driverOriginal.name,
              buttons: {
                warning: {
                  className: "btn-default",
                  label: $filter("translate")("Cancel")
                },
                success: {
                  className: "btn-primary",
                  label: $filter("translate")("Ok"),
                  callback: function() {
                    if (!$scope.driverToEdit.supportedLanguage) {
                      delete $scope.driverToEdit.supportedLanguage;
                    }
                    $scope.printQueue.editDriver($scope.driverOriginal, $scope.driverToEdit).then(function(response) {
                      if (response && response.data) {
                        var driverIndex = $scope.driverList.indexOf(driver);
                        response.data.isSelected = driver.isSelected;
                        $scope.driverList[driverIndex] = response.data;
                        toastr.success($filter("translate")("ChangesSaved"));
                      }
                    }).catch(function(error) {});
                  }
                }
              }
            };
            $ngBootbox.customDialog(driverEditOptions);
          } else {
            throw "$scope.editDriverComment: driver is missing";
          }
        };

        $scope.getDriverLanguage = function (driver) {
          if (driver.supportedLanguage) {
            for (var i = 0; i < $rootScope.sharedCaptionList.length; i++) {
              if (driver.supportedLanguage === $rootScope.sharedCaptionList[i].LanguageCode) {
                return $rootScope.sharedCaptionList[i].NativeName;
              }
            }
          } else {
            return $filter("translate")("LanguageUnknown");
          }
        }

        function attachLanguageToFilters () {
          for (var i = 0; i < $rootScope.sharedCaptionList.length; i++) {
            var languageObject = {
              key: $rootScope.sharedCaptionList[i].LanguageCode,
              value: $rootScope.sharedCaptionList[i].NativeName,
              type: 'checkbox'
            }
            $scope.filtersList[1].values.push(languageObject);
          }
        }

        $scope.selectCurrentDriver = function() {
          if ($scope.driverList && $scope.driverList.length > 0) {
            if ($scope.driver) {
              angular.forEach($scope.driverList, function(driverFromList) {
                if ([{ info: { _links: { self: { href: $scope.driver._links.self.href } } } }].findAllElements({ info: { _links: { self: { href: driverFromList._links.self.href } } } }).length > 0) {
                  if ($scope.currentDriver) {
                    driverFromList.isSelected = true;
                  }
                } else {
                  driverFromList.isSelected = false;
                }
              });
            }
            $scope.driverList = $filter("orderBy")($scope.driverList, "-isSelected");
          }
        };

        $scope.returnToPrintQueue = function () {
          var printerId = $routeParams[URL_PARAMS.PRINTER_URL.ROUTE];
          var queueId = $routeParams[URL_PARAMS.PRINT_QUEUE_URL.ROUTE];
          var url = `/printQueueProperties/${printerId}/${queueId}`
          $location.path(url).search(URL_PARAMS.SHOW_QUEUE_SECTION.ROUTE, 'drivers');
        }

        $scope.driverChangeCompleted = function() {
          toastr.success($filter("translate")("ChangesSaved"));
          $scope.defaultDriverReady = false;
          $scope.currentDriverReady = false;
          $scope.newDriver = null;
          getPrintQueue();
          findCorrectOS();
        };

        $scope.confirmButtonPress = function() {
          var selectedDriverList = $scope.driverList.findAllElements({ isSelected: true });
          if (selectedDriverList && selectedDriverList.length === 1) {
            $scope.printQueue.addDriver(selectedDriverList[0], $scope.os, $scope.currentDriver).then(function() {
              $scope.driverChangeCompleted();
            }).catch(function(error) {});
          } else {
            if ($scope.printQueue.info._embedded.driversAndConfigs &&
              $scope.printQueue.info._embedded.driversAndConfigs.findElement({os: $scope.os.key})) {
              $scope.printQueue.deleteDriver($scope.os).then(function() {
                $scope.driverChangeCompleted();
              }).catch(function(error) {});
            }
          }
        };

        function setFilters() {
          $scope.$watch(function(){
            return $rootScope.sharedCaptionList;
          }, function(){
            if ($rootScope.sharedCaptionList) {
              $scope.filtersList = DRIVER_FILTERS;
              attachLanguageToFilters();
              $scope.driverLanguages = $rootScope.sharedCaptionList;
            }
          }, true)
        }

        function getPrintQueue() {
          var printerId = $routeParams[URL_PARAMS.PRINTER_URL.ROUTE];
          var queueId = $routeParams[URL_PARAMS.PRINT_QUEUE_URL.ROUTE];
          var url = `${$scope.tenant.info._links["px:printers"].href}/${printerId}/queues/${queueId}`;
          PrintQueueListService.getPrintQueueByURL(url).then(function(printQueue) {
            getPrinter(printQueue);
            $scope.printQueue = angular.copy(printQueue);
            $scope.isAnywherePrintQueue = !isNaN(parseInt($scope.printQueue.info.signId));
          }).catch(function(error) {});
        }

        function getPrinter(printQueue) {
          PrinterListService.getPrinterByURL(printQueue.info._links["px:printer"].href).then(function(printer) {
            $scope.printer = angular.copy(printer);
            $scope.getCurrentDriver();
            $scope.getDefaultDriver();
            getNetwork(printer);
          }).catch(function(error) {});
        }

        function getNetwork(printer) {
          if (printer.info._links['px:network']) {
            const networkId = printer.info._links['px:network'].href.split('networks/').pop();
            NetworkListService.getNetworkById(networkId)
              .then(function (network) {
                isThisResourceMine(network);
              })
              .catch(function () {
              });
          }
        }

        function isThisResourceMine(network) {
          const siteUrl = network?.info._links['px:site']?.href;
          $scope.isThisResourceMine = $scope.me.isThisSiteMine(siteUrl);
        }

        function findCorrectOS() {
          $scope.os = SUPPORTED_OS.findElement({
            key: $routeParams[URL_PARAMS.OS.ROUTE]
          });
        }

        $scope.getCurrentDriver = function() {
          var printQueueDriverLink = PrinterListService.getDriverForPrintQueueOS($scope.printer, $scope.printQueue, $scope.os.key, true);
          $scope.printQueue.getDriverByUrl(printQueueDriverLink).then(function(response) {
            $scope.currentDriver = response.data;
            $scope.currentDriverReady = true;
            $scope.noDrivers.currentDriver = false;
            $scope.compareCurrentAndDefaultDriver();
          }).catch(function(error) {
            $scope.noDrivers.currentDriver = true;
            $scope.currentDriver = null;
            usePrinterModelAsSearchCriteria();
          })
        }

        $scope.getDefaultDriver = function(defaultPrintQueueDriver) {
          if ($scope.printer.info._embedded.defaultDrivers) {
            var defaultPrintQueueDriver = $scope.printer.info._embedded.defaultDrivers.findElement({
              operatingSystem: $scope.os.key
            });
            if (defaultPrintQueueDriver) {
              var url = defaultPrintQueueDriver._links.self.href;
            }
          }
          $scope.printQueue.getDriverByUrl(url).then(function(response) {
            $scope.defaultDriver = response.data;
            $scope.defaultDriverReady = true;
            $scope.noDrivers.defaultDriver = false;
            $scope.compareCurrentAndDefaultDriver();
          }).catch(function(error) {
            $scope.noDrivers.defaultDriver = true;
            $scope.defaultDriver = null;
            usePrinterModelAsSearchCriteria();
          })
        }

        function usePrinterModelAsSearchCriteria() {
          if ($scope.noDrivers.defaultDriver && $scope.noDrivers.currentDriver) {
            $scope.searchPattern = $scope.printer.info._embedded.printerModel.modelName;
          }
        }

        $scope.compareCurrentAndDefaultDriver = function() {
          if (($scope.currentDriverReady && $scope.defaultDriverReady)) {
            if ($scope.defaultDriver._links.self.href === $scope.currentDriver._links.self.href) {
              $scope.driver = angular.copy($scope.defaultDriver);
              $scope.searchPattern = angular.copy($scope.driver.name);
              if (!$scope.isPrintQueueOsDriverLocked($scope.os)) {
                $scope.currentDriver = null;
              }
            } else {
              $scope.driver = angular.copy($scope.currentDriver);
              $scope.searchPattern = angular.copy($scope.driver.name);
            }
          } else if ($scope.currentDriverReady && $scope.noDrivers.defaultDriver) {
            $scope.driver = angular.copy($scope.currentDriver);
            $scope.searchPattern = angular.copy($scope.driver.name);
          }
        }

        $scope.isPrintQueueOsDriverLocked = function (os) {
          if (os) {
            if ($scope.printQueue.info._embedded.driversAndConfigs && $scope.printQueue.info._embedded.driversAndConfigs.findAllElements({os: os.key}).length > 0) {
              return true;
            } else {
              return false;
            }
          } else {
            throw "$scope.isPrintQueueOsDriverLocked: os is missing";
          }
        };

        angular.element($window).on("scroll", function() {
          if (this.pageYOffset >= 210) {
            angular.element('.icon-lock-open').addClass('fix-lock-position-2');
            angular.element('.icon-lock').addClass('fix-lock-position');
            $scope.fixDefaultDriver = true;
          } else {
            angular.element('.icon-lock-open').removeClass('fix-lock-position-2');
            angular.element('.icon-lock').removeClass('fix-lock-position');
            $scope.fixDefaultDriver = false;
          }
          var calculatedWidth = angular.element('.driver-highlight-container').width();
          angular.element('.driver-highlight').css({width: calculatedWidth});
          angular.element('.return-btn').css({width: calculatedWidth});
          $scope.$apply();
        });

        angular.element($window).on('resize', function() {
          var calculatedWidth = angular.element('.driver-highlight-container').width();
          angular.element('.driver-highlight').css({width: calculatedWidth});
          angular.element('.return-btn').css({width: calculatedWidth});
          $scope.$apply();
        })
        $scope.openPrinterProperties = function () {
          $scope.printerUrl = URLS.PRINTER_PROPERTIES.replace(URL_PARAMS.PRINTER_URL.LOCATION, $scope.printer.customProperties.id);
          $location.path($scope.printerUrl).search(URL_PARAMS.SHOW_PRINTER_SECTION.ROUTE, 'setup');
        };

      }
    ]);
})();